import { render, staticRenderFns } from "./verifyPhone.vue?vue&type=template&id=51bc3c8e&scoped=true&"
import script from "./verifyPhone.vue?vue&type=script&lang=js&"
export * from "./verifyPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc3c8e",
  null
  
)

export default component.exports